module.exports = __webpack_public_path__ + "photo2@2x.png?d5dbcd726eea160ebb0a08ac4342eb07";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photo2@2x.png
// module id = 58
// module chunks = 0